(() => {
  const initScreenGrids = (root = document) => {
    const grids = root.matches?.('[data-screen-grid]')
      ? [root]
      : root.querySelectorAll('[data-screen-grid]');

    grids.forEach((grid) => {
      if (grid.dataset.screenGridInitialized) return;

      const items = [...grid.querySelectorAll('.screen_02__item')];
      if (!items.length) return;

      grid.dataset.screenGridInitialized = 'true';
      let layoutFrame = 0;
      let observedWidth = 0;

      const layout = () => {
        const gridWidth = grid.clientWidth;
        if (!gridWidth) return;

        const isMobile = window.innerWidth <= 700;
        const isTablet = window.innerWidth <= 1024;
        const columns = isMobile ? 1 : isTablet ? 2 : 3;
        const gap = isMobile ? 18 : 24;
        const columnWidth = (gridWidth - gap * (columns - 1)) / columns;
        const columnHeights = Array(columns).fill(0);

        items.forEach((item) => {
          item.style.width = `${columnWidth}px`;
          item.style.left = '0px';
          item.style.top = '0px';
        });

        items.forEach((item) => {
          const shortestColumn = columnHeights.indexOf(Math.min(...columnHeights));
          const itemHeight = item.offsetHeight;
          item.style.left = `${shortestColumn * (columnWidth + gap)}px`;
          item.style.top = `${columnHeights[shortestColumn]}px`;
          columnHeights[shortestColumn] += itemHeight + gap;
        });

        grid.style.height = `${Math.max(...columnHeights) - gap}px`;
      };

      const scheduleLayout = () => {
        cancelAnimationFrame(layoutFrame);
        layoutFrame = requestAnimationFrame(layout);
      };

      grid.querySelectorAll('img').forEach((image) => {
        image.addEventListener('load', scheduleLayout);
        image.addEventListener('error', scheduleLayout);

        if (image.complete) {
          image.decode?.().catch(() => {}).finally(scheduleLayout);
        }
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          const nextWidth = grid.clientWidth;
          if (nextWidth === observedWidth) return;
          observedWidth = nextWidth;
          scheduleLayout();
        });
        resizeObserver.observe(grid);
      }
      else {
        window.addEventListener('resize', scheduleLayout);
      }

      scheduleLayout();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScreenGrids(), { once: true });
  }
  else {
    initScreenGrids();
  }

  document.addEventListener('shopify:section:load', (event) => initScreenGrids(event.target));
})();
